import React, { useEffect, useMemo, useState } from "react";
import SpinImageHi from "../../../assets/images/spinImage_hi.png";
import SpinImageMr from "../../../assets/images/spinImage_mr.png";
import SpinImageKa from "../../../assets/images/spinImage_ka.png";
import SpinImageTe from "../../../assets/images/spinImage_te.png";
import SpinImageGj from "../../../assets/images/spinImage_gj.png";
import SpinImagePb from "../../../assets/images/spinImage_pb.png";
import SpinImageTa from "../../../assets/images/spinImage_ta.png";
import SpinImageBn from "../../../assets/images/spinImage_ba.png";
import SpinImageEn from "../../../assets/images/spinImage_en.png";
import LeftArrow from "../../../assets/images/left.png";
import RightArrow from "../../../assets/images/rightArrow.png";
import Layout from "../../layout";
import CustomModal from "../../modal";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../loader";
import CustomRoulette from "../../WheelComponent";
import { useTranslation } from "react-i18next";
import { fetchAPI } from "../../service/Encrtyption";
import { spinStatus, genuityCheckData, scanData } from "../../auth/redux/store";
import { useNavigate, useParams } from "react-router-dom";
import SuccessIcon from "../../../assets/images/successIcon.png";
import Close from "../../../assets/images/close.png";
import ReactGA from "react-ga4";
import Wrongotp from "../../../assets/images/wrongotp.png";
import Check from "../../../assets/images/check.png";
import {
  getScanLimitNotice,
  isScanLimitReached,
} from "../../../utils/genuityCheck";

import { EmpoverScanner } from "@empover/react-web-scanner";
import "@empover/react-web-scanner/styles.css";
import { convertMediaUrls } from "../../../utils/authenticatedImages";

const scannerLanguageMap = {
  en: "en-IN",
  hi: "hi-IN",
  te: "te-IN",
  ta: "ta-IN",
  kn: "kn-IN",
  ka: "kn-IN",
  mr: "mr-IN",
  gu: "gu-IN",
  pa: "pa-IN",
  pb: "pa-IN",
  bn: "bn-IN",
  ba: "bn-IN",
  or: "or-IN",
  od: "or-IN",
  ml: "ml-IN",
  ma: "ml-IN",
};

const scannerLanguageAliases = {
  ba: "bn",
  gj: "gu",
  ka: "kn",
  od: "or",
  pb: "pa",
  ma: "ml",
};

const scannerPermissionErrorMessages = {
  en: {
    CAMERA_PERMISSION_DENIED:
      "Camera access is required. Allow camera permission in your browser site settings and try again.",
    CAMERA_UNAVAILABLE: "No compatible camera is available on this device.",
    INSECURE_CONTEXT: "Camera scanning requires HTTPS outside localhost.",
    LOCATION_PERMISSION_DENIED:
      "Location access is required to attach your scan location.",
    UNSUPPORTED_BROWSER: "This browser does not support camera scanning.",
  },
  hi: {
    CAMERA_PERMISSION_DENIED:
      "कैमरा अनुमति आवश्यक है। कृपया ब्राउज़र सेटिंग में कैमरा अनुमति दें।",
    CAMERA_UNAVAILABLE: "इस डिवाइस पर कैमरा उपलब्ध नहीं है।",
    INSECURE_CONTEXT: "कैमरा स्कैनिंग के लिए HTTPS आवश्यक है।",
    LOCATION_PERMISSION_DENIED:
      "स्थान अनुमति आवश्यक है। कृपया लोकेशन अनुमति दें।",
    UNSUPPORTED_BROWSER: "यह ब्राउज़र कैमरा स्कैनिंग को सपोर्ट नहीं करता।",
  },
  te: {
    CAMERA_PERMISSION_DENIED:
      "కెమెరా అనుమతి అవసరం. దయచేసి బ్రౌజర్ సెట్టింగ్స్‌లో కెమెరా అనుమతిని ఇవ్వండి.",
    CAMERA_UNAVAILABLE: "ఈ డివైస్‌లో కెమెరా అందుబాటులో లేదు.",
    INSECURE_CONTEXT: "కెమెరా స్కానింగ్‌కు HTTPS అవసరం.",
    LOCATION_PERMISSION_DENIED:
      "లొకేషన్ అనుమతి అవసరం. దయచేసి లొకేషన్ అనుమతిని ఇవ్వండి.",
    UNSUPPORTED_BROWSER: "ఈ బ్రౌజర్ కెమెరా స్కానింగ్‌ను సపోర్ట్ చేయదు.",
  },
  ta: {
    CAMERA_PERMISSION_DENIED:
      "கேமரா அனுமதி தேவை. உலாவி அமைப்புகளில் கேமரா அனுமதியை வழங்கவும்.",
    CAMERA_UNAVAILABLE: "இந்த சாதனத்தில் கேமரா கிடைக்கவில்லை.",
    INSECURE_CONTEXT: "கேமரா ஸ்கேனிங்கிற்கு HTTPS தேவை.",
    LOCATION_PERMISSION_DENIED:
      "இருப்பிட அனுமதி தேவை. இருப்பிட அனுமதியை வழங்கவும்.",
    UNSUPPORTED_BROWSER: "இந்த உலாவி கேமரா ஸ்கேனிங்கை ஆதரிக்கவில்லை.",
  },
  kn: {
    CAMERA_PERMISSION_DENIED:
      "ಕ್ಯಾಮೆರಾ ಅನುಮತಿ ಅಗತ್ಯವಿದೆ. ದಯವಿಟ್ಟು ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಅನುಮತಿ ನೀಡಿ.",
    CAMERA_UNAVAILABLE: "ಈ ಡಿವೈಸ್‌ನಲ್ಲಿ ಕ್ಯಾಮೆರಾ ಲಭ್ಯವಿಲ್ಲ.",
    INSECURE_CONTEXT: "ಕ್ಯಾಮೆರಾ ಸ್ಕ್ಯಾನಿಂಗ್‌ಗೆ HTTPS ಅಗತ್ಯವಿದೆ.",
    LOCATION_PERMISSION_DENIED:
      "ಸ್ಥಳ ಅನುಮತಿ ಅಗತ್ಯವಿದೆ. ದಯವಿಟ್ಟು ಸ್ಥಳ ಅನುಮತಿ ನೀಡಿ.",
    UNSUPPORTED_BROWSER:
      "ಈ ಬ್ರೌಸರ್ ಕ್ಯಾಮೆರಾ ಸ್ಕ್ಯಾನಿಂಗ್ ಅನ್ನು ಬೆಂಬಲಿಸುವುದಿಲ್ಲ.",
  },
  mr: {
    CAMERA_PERMISSION_DENIED:
      "कॅमेरा परवानगी आवश्यक आहे. कृपया ब्राउझर सेटिंग्जमध्ये कॅमेरा परवानगी द्या.",
    CAMERA_UNAVAILABLE: "या डिव्हाइसवर कॅमेरा उपलब्ध नाही.",
    INSECURE_CONTEXT: "कॅमेरा स्कॅनिंगसाठी HTTPS आवश्यक आहे.",
    LOCATION_PERMISSION_DENIED:
      "स्थान परवानगी आवश्यक आहे. कृपया लोकेशन परवानगी द्या.",
    UNSUPPORTED_BROWSER: "हा ब्राउझर कॅमेरा स्कॅनिंगला सपोर्ट करत नाही.",
  },
  gu: {
    CAMERA_PERMISSION_DENIED:
      "કેમેરાની પરવાનગી જરૂરી છે. કૃપા કરીને બ્રાઉઝર સેટિંગ્સમાં કેમેરાની પરવાનગી આપો.",
    CAMERA_UNAVAILABLE: "આ ડિવાઇસ પર કેમેરા ઉપલબ્ધ નથી.",
    INSECURE_CONTEXT: "કેમેરા સ્કેનિંગ માટે HTTPS જરૂરી છે.",
    LOCATION_PERMISSION_DENIED:
      "સ્થાન પરવાનગી જરૂરી છે. કૃપા કરીને સ્થાનની પરવાનગી આપો.",
    UNSUPPORTED_BROWSER: "આ બ્રાઉઝર કેમેરા સ્કેનિંગને સપોર્ટ કરતું નથી.",
  },
  pa: {
    CAMERA_PERMISSION_DENIED:
      "ਕੈਮਰਾ ਇਜਾਜ਼ਤ ਲੋੜੀਂਦੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਬ੍ਰਾਊਜ਼ਰ ਸੈਟਿੰਗਾਂ ਵਿੱਚ ਕੈਮਰਾ ਇਜਾਜ਼ਤ ਦਿਓ।",
    CAMERA_UNAVAILABLE: "ਇਸ ਡਿਵਾਈਸ ਤੇ ਕੈਮਰਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
    INSECURE_CONTEXT: "ਕੈਮਰਾ ਸਕੈਨਿੰਗ ਲਈ HTTPS ਲਾਜ਼ਮੀ ਹੈ।",
    LOCATION_PERMISSION_DENIED:
      "ਸਥਾਨ ਇਜਾਜ਼ਤ ਲੋੜੀਂਦੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਲੋਕੇਸ਼ਨ ਇਜਾਜ਼ਤ ਦਿਓ।",
    UNSUPPORTED_BROWSER: "ਇਹ ਬ੍ਰਾਊਜ਼ਰ ਕੈਮਰਾ ਸਕੈਨਿੰਗ ਨੂੰ ਸਪੋਰਟ ਨਹੀਂ ਕਰਦਾ।",
  },
  bn: {
    CAMERA_PERMISSION_DENIED:
      "ক্যামেরার অনুমতি প্রয়োজন। অনুগ্রহ করে ব্রাউজার সেটিংসে ক্যামেরার অনুমতি দিন।",
    CAMERA_UNAVAILABLE: "এই ডিভাইসে ক্যামেরা উপলব্ধ নেই।",
    INSECURE_CONTEXT: "ক্যামেরা স্ক্যানিংয়ের জন্য HTTPS প্রয়োজন।",
    LOCATION_PERMISSION_DENIED:
      "লোকেশন অনুমতি প্রয়োজন। অনুগ্রহ করে লোকেশন অনুমতি দিন।",
    UNSUPPORTED_BROWSER: "এই ব্রাউজার ক্যামেরা স্ক্যানিং সমর্থন করে না।",
  },
  or: {
    CAMERA_PERMISSION_DENIED:
      "କ୍ୟାମେରା ଅନୁମତି ଆବଶ୍ୟକ। ଦୟାକରି ବ୍ରାଉଜର ସେଟିଂସରେ କ୍ୟାମେରା ଅନୁମତି ଦିଅନ୍ତୁ।",
    CAMERA_UNAVAILABLE: "ଏହି ଡିଭାଇସରେ କ୍ୟାମେରା ଉପଲବ୍ଧ ନାହିଁ।",
    INSECURE_CONTEXT: "କ୍ୟାମେରା ସ୍କାନିଂ ପାଇଁ HTTPS ଆବଶ୍ୟକ।",
    LOCATION_PERMISSION_DENIED:
      "ଲୋକେସନ ଅନୁମତି ଆବଶ୍ୟକ। ଦୟାକରି ଲୋକେସନ ଅନୁମତି ଦିଅନ୍ତୁ।",
    UNSUPPORTED_BROWSER:
      "ଏହି ବ୍ରାଉଜର କ୍ୟାମେରା ସ୍କାନିଂକୁ ସପୋର୍ଟ କରେନାହିଁ।",
  },
  ml: {
    CAMERA_PERMISSION_DENIED:
      "ക്യാമറ അനുമതി ആവശ്യമാണ്. ദയവായി ബ്രൗസർ ക്രമീകരണങ്ങളിൽ ക്യാമറ അനുമതി നൽകുക.",
    CAMERA_UNAVAILABLE: "ഈ ഉപകരണത്തിൽ ക്യാമറ ലഭ്യമല്ല.",
    INSECURE_CONTEXT: "ക്യാമറ സ്കാനിംഗിന് HTTPS ആവശ്യമാണ്.",
    LOCATION_PERMISSION_DENIED:
      "ലൊക്കേഷൻ അനുമതി ആവശ്യമാണ്. ദയവായി ലൊക്കേഷൻ അനുമതി നൽകുക.",
    UNSUPPORTED_BROWSER:
      "ഈ ബ്രൗസർ ക്യാമറ സ്കാനിംഗിനെ പിന്തുണയ്ക്കുന്നില്ല.",
  },
};

const getScannerLanguageCode = (language) => {
  const languageCode = String(language || "en")
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];

  return scannerLanguageAliases[languageCode] || languageCode || "en";
};

const getScannerLanguage = (language) => {
  const languageCode = getScannerLanguageCode(language);
  return scannerLanguageMap[languageCode] || scannerLanguageMap.en;
};

const scanCorrectlyMessages = {
  en: "Please scan the QR code correctly.",
  hi: "कृपया QR कोड सही से स्कैन करें।",
  pa: "ਕਿਰਪਾ ਕਰਕੇ QR ਕੋਡ ਸਹੀ ਤਰੀਕੇ ਨਾਲ ਸਕੈਨ ਕਰੋ।",
  bn: "অনুগ্রহ করে QR কোড সঠিকভাবে স্ক্যান করুন।",
  te: "దయచేసి QR కోడ్‌ను సరిగ్గా స్కాన్ చేయండి.",
  kn: "ದಯವಿಟ್ಟು QR ಕೋಡ್ ಅನ್ನು ಸರಿಯಾಗಿ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ.",
  or: "ଦୟାକରି QR କୋଡ୍ ସଠିକ୍ ଭାବରେ ସ୍କାନ୍ କରନ୍ତୁ।",
};


const getScanCorrectlyMessage = (language) => {
  const languageCode = getScannerLanguageCode(language);
  return scanCorrectlyMessages[languageCode] || scanCorrectlyMessages.en;
};

const getScannerPermissionErrorMessage = (error, language) => {
  const languageCode = getScannerLanguageCode(language);
  return (
    scannerPermissionErrorMessages[languageCode]?.[error?.code] ||
    error?.message ||
    scannerPermissionErrorMessages.en.CAMERA_PERMISSION_DENIED
  );
};

const isTorchControlError = (error) => {
  const message = String(error?.message || "").toLowerCase();
  return (
    message.includes("camera torch") ||
    message.includes("torch could not be changed") ||
    message.includes("flash could not be changed")
  );
};

// Only a full http(s) URL is accepted. Half / blurry / noise scans are ignored.
const isFullHttpUrl = (value) => {
  const scannedValue = String(value || "").trim();
  if (!scannedValue.startsWith("http://") && !scannedValue.startsWith("https://")) {
    return false;
  }
  try {
    const parsed = new URL(scannedValue);
    // Real product QRs have a domain (e.g. example.com), not short fragments.
    return Boolean(parsed.hostname) && parsed.hostname.includes(".");
  } catch {
    return false;
  }
};

const scannerVerifier = async (request) => {
  const qrCodeValue = request?.payload?.qrCodeValue || "";

  return {
    statusCode: 100,
    responseObject: {
      message: "Scanned successfully",
      barCodeScannedValue: qrCodeValue,
    },
  };
};

export const ScanProduct = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLanguage = lang;
  const productName = sessionStorage.getItem("storedProductName");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state?.user);
  const giftImageUrl = useSelector((state) => state?.giftImageUrl);

  const mbno = user?.mobileNumber || sessionStorage.getItem("mbn") || "";
  const cid = user?.customerId || sessionStorage.getItem("cid") || "";

  const [isOpen, setIsOpen] = useState(true);
  const [scanError, setScanError] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [spinModalShow, setSpinModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cameraStarting, setCameraStarting] = useState(false);
  const [cameraReady, setCameraReady] = useState(false);
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [errorModalGenunity, setErrorModalGenunity] = useState(false);
  const [retailerMblNbr, setRetailerMblNbr] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [showRetailerInput, setShowRetailerInput] = useState(false);
  const [stopPrizeNumber] = useState(null);
  const [scanedDataObject, setScanedDataObject] = useState({});
  const [secondaryRewardMsg, setSecondaryRewardMsg] = useState("");
  // const scanedData = useSelector((state) => state.scandataUrl); 
  // console.log(JSON.stringify(scanedData) + "scanedData");  
  // const firstScanUrlData1 = JSON.parse(scanedData);
  // const [firstScanUrlData, setFirstScanUrlData] = useState(firstScanUrlData1);

  const scanedData = useSelector((state) => state.scandataUrl);

  let firstScanUrlData1 = {};

  try {
    firstScanUrlData1 =
      typeof scanedData === "string"
        ? JSON.parse(scanedData)
        : scanedData || {};
  } catch (error) {
    console.error("Invalid JSON:", error);
    firstScanUrlData1 = {};
  }

  const [firstScanUrlData, setFirstScanUrlData] = useState(firstScanUrlData1);

  // const scanLimitReached = isScanLimitReached(scanedDataObject);
  const scanLimitReached = scanedDataObject?.maxAcresReached;
  const scanLimitNotice =
    getScanLimitNotice(scanedDataObject) || scanedDataObject.uq_message || t("genuityCheck.scanLimitFallback");
  const scannerLanguage = getScannerLanguage(currentLanguage);

  const scannerConfig = useMemo(
    () => ({
      user: {
        fullName: user?.fullName || user?.name || "Demo User",
        email: user?.email || "demo@example.com",
        loginToken: user?.loginToken || "USER_LOGIN_TOKEN",
        mobileNumber: mbno || "0000000000",
        userId: cid || "EMP12345",
      },
      environment: "TEST",
      scannerType: "DEFAULT",
      language: scannerLanguage,
      locationMode: "optional",
      enableAutoZoom: false,
      enableAutoTorch: false,
      useAsGenericScanner: true,
    }),
    [user, mbno, cid, scannerLanguage]
  );

  useEffect(() => {
    if (!isOpen) {
      setCameraStarting(false);
      setCameraReady(false);
      return undefined;
    }

    let stopped = false;
    let frameId = 0;

    setCameraStarting(true);
    setCameraReady(false);

    const checkCameraReady = () => {
      if (stopped) return;

      const video = document.querySelector(".client-camera-frame video");

      if (video && video.readyState >= 2 && video.videoWidth > 0) {
        setCameraReady(true);
        setCameraStarting(false);
        return;
      }

      frameId = window.requestAnimationFrame(checkCameraReady);
    };

    frameId = window.requestAnimationFrame(checkCameraReady);

    return () => {
      stopped = true;
      window.cancelAnimationFrame(frameId);
    };
  }, [isOpen]);

  const getScan = async (scanRequest, scannedUrl) => {
    setLoading(true);

    ReactGA.event({
      category: "User Scan staus",
      action: "SCAN_STATUS",
    });

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL_SCAN,
        scanRequest,
        {
          customerId: scanRequest.customerId || cid,
          mobileNumber: scanRequest.mobileNumber || mbno,
          userAuthorizationToken: "",
          deviceid: "WEB",
          appLangCode: currentLanguage,
        }
      );

      console.log(JSON.stringify(scanRequest) + "scanRequest");

      const jsonReposneData =
        typeof responseData === "string" ? JSON.parse(responseData) : responseData;
      const mediaData = await convertMediaUrls(jsonReposneData);
      console.log(mediaData, "otp response mediaData data"); 
      console.log("SCANRESPONSE", jsonReposneData);
      setShowRetailerInput(jsonReposneData?.isShowReatilerMobileNumber);

      if (
        String(jsonReposneData?.statusCode) === "200" &&
        String(jsonReposneData?.uq_responseCode) === "100"
      ) {
        const ourProductNames = ["gallant"];
        const productNameFromApi = jsonReposneData?.productName?.toLowerCase();

        if (
          productNameFromApi &&
          ourProductNames.some((product) =>
            productNameFromApi.includes(product.toLowerCase())
          )
        ) {
          setScanedDataObject(mediaData);
          setSecondaryRewardMsg(jsonReposneData.secondaryRewardMsg);
          dispatch(genuityCheckData(mediaData));
          setLoading(false);

          if (jsonReposneData.isSpinDone === true && jsonReposneData.isAlreadyScannedProduct) {
            setErrorModalGenunity(true);
            return;
          }

          if (jsonReposneData.isAlreadyScannedProduct) {
            setErrorModalGenunity(true);
            return;
          }

          // if (jsonReposneData.isSpinDone === true && jsonReposneData.isAlreadyScannedProduct) {
          //   setErrorModalGenunity(true);
          //   return;
          // }

          setModalShow(true);
        } else {
          window.location.href = scannedUrl;
        }
      } else if (String(jsonReposneData?.uq_responseCode) !== "100") {
        setLoading(false);
        setScanedDataObject(mediaData);
        setErrorModalGenunity(true);
      }
    } catch (error) {
      console.error("Error fetching API:", error);
      setLoading(false);
      setScanError({
        message: error?.message || "Unable to verify scan.",
      });
    }
  };

  const restartScanner = () => {
    // Empover stops the camera after every result; force open toggle to restart it.
    setIsOpen(false);
    setCameraStarting(false);
    setCameraReady(false);
    window.setTimeout(() => {
      setIsOpen(true);
    }, 200);
  };

  const handleScannerResult = (result) => {

    const scannedQrValue = String(
      result?.response?.barCodeScannedValue ||
      result?.payload?.qrCodeValue ||
      ""
    ).trim();

    console.log("scanned QR value:", scannedQrValue);

    // Partial / blurry / non-URL decode: show localized message, restart camera, no API.
    if (!isFullHttpUrl(scannedQrValue)) {
      const activeLanguage = currentLanguage;
      setLoading(false);
      setScanError({ message: getScanCorrectlyMessage(activeLanguage) });
      restartScanner();
      return;
    }

    setIsOpen(false);
    setCameraStarting(false);
    setCameraReady(false);
    setScanError(null);

    ReactGA.event({
      category: "User Scan Other products",
      label: "Scan Other Products",
      action: "Scan Other Products",
    });

    // const barcodeText = result?.response?.barCodeScannedValue || "";
    // const decodedBarcode = decodeURIComponent(barcodeText);
    // console.log(decodedBarcode);

    // if (!scannedQrValue) {
    //   setScanError({ message: "Scanner did not return a barcode value." });
    //   return;
    // }

    const updatedScanedDataObject = {
      ...scanedDataObject,
      completeUrl: scannedQrValue,
      product: productName,
      district: firstScanUrlData.district,
      state: firstScanUrlData.state,
      cropList: firstScanUrlData.cropList,
      longitude: firstScanUrlData.longitude,
      latitude: firstScanUrlData.latitude,
      otp: "",
      mobileNumber: mbno,
      customerId: cid,
      otpVerified: true,
      deviceId: "",
      deviceType: "WEB",
      countryId: 5,
      destinationURL: "/customer/saveGenuinityCheckDetails_V3_acviss",
      moduleType: productName,
      appLangCode: currentLanguage,
      directScanConsentAgreed: true,
    };
    // dispatch(scanData(updatedScanedDataObject));
    getScan(updatedScanedDataObject, scannedQrValue);
  };

  const handleCloseModal = () => {
    setSpinModalShow(false);
    setRewardUpdateModal(true);
  };

  const handleMblInput = (event) => {
    const numericValue = event.target.value.replace(/\D/g, "");
    const limitedValue = numericValue.slice(0, 10);
    const validValue = /^[6-9]\d{0,9}$/.test(limitedValue) ? limitedValue : "";

    event.target.value = validValue;
    setRetailerMblNbr(validValue);
  };

  const handleSpin = () => {
    if (retailerMblNbr.length < 10 && retailerMblNbr.length !== 0) {
      setMobileNumberError(t("mobileErrorMsg"));
    } else {
      setMobileNumberError("");
      dispatch(spinStatus(true, retailerMblNbr));
    }
  };

  const handleGenuityProceedCashback = () => {
    if (scanLimitReached) return;

    ReactGA.event({
      category: "User Proceed to Cashback",
      action: "Clicked the Proceed to Cashback Button",
    });

    setModalShow(false);
    // navigate(`/${lang}/rewardjourney`);

    if (scanedDataObject?.isGiftClaimed) {
      navigate(`/${lang}/giftClaim`);
      return;
    }

    if (scanedDataObject.isSpinDone) {
      navigate(`/${lang}/spinNotApplicable`);
    } else {
      navigate(`/${lang}/spinwheel`);
    }
  };

  const bannerLogoMap = {
    hi: SpinImageHi,
    mr: SpinImageMr,
    kn: SpinImageKa,
    te: SpinImageTe,
    pa: SpinImagePb,
    gu: SpinImageGj,
    ta: SpinImageTa,
    bn: SpinImageBn,
    en: SpinImageEn,
    or: SpinImageHi,
    ma: SpinImageHi,
  };

  const bannerLogoSrc = bannerLogoMap[lang] || SpinImageHi;

  return (
    <>
      <style>
        {`
          .client-scan-page {
            min-height: calc(100dvh - 80px);
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .client-camera-frame {
            position: relative;
            width: min(58vw, 240px);
            aspect-ratio: 1;
            margin: 120px auto 110px;
            overflow: hidden;
            background: #ffffff;
            border-radius: 12px;
          }

          .client-camera-loader {
            position: absolute;
            z-index: 4;
            inset: 0;
            display: grid;
            place-items: center;
            background: #ffffff;
            pointer-events: none;
          }

          .client-camera-loader::before {
            width: 34px;
            height: 34px;
            content: "";
            border: 4px solid rgba(41, 179, 74, 0.2);
            border-top-color: #29b34a;
            border-radius: 50%;
            animation: client-camera-spin 0.8s linear infinite;
          }

          .client-camera-placeholder,
          .client-camera-only-scanner {
            position: absolute;
            inset: 0;
          }

          .client-camera-placeholder {
            z-index: 0;
            background: #ffffff;
          }

          .client-camera-only-scanner.empover-scanner {
            z-index: 1;
            width: 100%;
            height: 100%;
            min-width: 0;
            min-height: 0;
            margin: 0;
            padding: 0;
            border: 0;
            border-radius: 0;
            background: transparent;
          }

          .client-camera-only-scanner .empover-scanner__camera {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            overflow: hidden;
            background: #ffffff;
          }

          .client-camera-only-scanner .empover-scanner__video {
            display: block;
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            object-fit: cover;
            object-position: center center;
            border: 0;
            border-radius: 0;
          }

          .client-camera-frame:not(.is-ready) .client-camera-only-scanner .empover-scanner__video {
            opacity: 0;
          }

          .client-camera-only-scanner .empover-scanner__shade,
          .client-camera-only-scanner .empover-scanner__toolbar,
          .client-camera-only-scanner .empover-scanner__find,
          .client-camera-only-scanner .empover-scanner__focus,
          .client-camera-only-scanner .empover-scanner__zoom,
          .client-camera-only-scanner .empover-scanner__controls,
          .client-camera-only-scanner .empover-scanner__status,
          .client-camera-only-scanner .empover-scanner__brand,
          .client-camera-only-scanner .empover-scanner__modal-backdrop {
            display: none !important;
          }

          .client-scan-corner {
            position: absolute;
            z-index: 6;
            width: 60px;
            height: 60px;
            border-color: #29b34a;
            border-style: solid;
            filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.22));
            pointer-events: none;
          }

          .client-scan-corner--tl {
            top: 0;
            left: 0;
            border-width: 5px 0 0 5px;
            border-radius: 12px 0 0 0;
          }

          .client-scan-corner--tr {
            top: 0;
            right: 0;
            border-width: 5px 5px 0 0;
            border-radius: 0 12px 0 0;
          }

          .client-scan-corner--bl {
            bottom: 0;
            left: 0;
            border-width: 0 0 5px 5px;
            border-radius: 0 0 0 12px;
          }

          .client-scan-corner--br {
            right: 0;
            bottom: 0;
            border-width: 0 5px 5px 0;
            border-radius: 0 0 12px 0;
          }

          .client-scan-button-wrap {
            width: min(86vw, 312px);
            margin: 0 auto;
          }

          .client-scan-button {
            width: 100%;
            min-height: 48px;
          }

          .client-whatsapp-help {
            margin-top: 16px;
            color: #1b2aa5;
            text-decoration: underline;
          }

          @keyframes client-camera-spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <Layout>
        <div className="container p-0">
          {loading && <Loader />}

          <div className="card border-0">
            <div className="card-header bg-white border-0 pb-0">
              <span className="text-center card-header_title mb-4">
                {t("scanTitle")}
              </span>
            </div>

            <div className="card-body px-2 pt-0 pb-2">
              <div className="container client-scan-page">

                {scanError && (
                  <p className="text-danger text-center mt-3">
                    {scanError.message}
                  </p>
                )}

                <div
                  className={`client-camera-frame ${cameraReady ? "is-ready" : ""
                    }`}
                >
                  <div className="client-camera-placeholder" />

                  <EmpoverScanner
                    open={isOpen}
                    presentation="inline"
                    className="client-camera-only-scanner"
                    config={scannerConfig}
                    verifier={scannerVerifier}
                    strings={{
                      readyTitle: "",
                      readyDetail: "",
                      verifyingTitle: "",
                      verifyingDetail: "",
                    }}
                    onResult={handleScannerResult}
                    // onError={(error) => {
                    //   if (isTorchControlError(error)) {
                    //     console.warn(
                    //       `Scanner torch warning ignored: ${error.message}`
                    //     );
                    //     return;
                    //   }
                    //   setIsOpen(false);
                    //   setCameraStarting(false);
                    //   setCameraReady(false);
                    //   setScanError({
                    //     ...error,
                    //     message: getScannerPermissionErrorMessage(
                    //       error,
                    //       currentLanguage
                    //     ),
                    //   });
                    //   console.error(
                    //     `Scanner error: ${error.code} - ${error.message}`
                    //   );
                    // }}

                    onError={(error) => {
                      if (isTorchControlError(error)) {
                        console.warn(
                          `Scanner torch warning ignored: ${error.message}`
                        );
                        return;
                      }

                      // Verifier rejected a partial / invalid decode.
                      const message = String(error?.message || "").toLowerCase();
                      const isInvalidQr =
                        Number(error?.code) === 400 ||
                        message.includes("full qr") ||
                        message.includes("invalid");

                      setLoading(false);
                      setCameraStarting(false);

                      if (isInvalidQr) {
                        const activeLanguage = currentLanguage;
                        setScanError({
                          message: getScanCorrectlyMessage(activeLanguage),
                        });
                        restartScanner();
                        return;
                      }

                      setIsOpen(false);
                      setCameraReady(false);
                      setScanError({
                        ...error,
                        message: getScannerPermissionErrorMessage(
                          error,
                          currentLanguage
                        ),
                      });
                      console.error(
                        `Scanner error: ${error.code} - ${error.message}`
                      );
                    }}

                    onCancel={() => {
                      setIsOpen(false);
                      setCameraStarting(false);
                      setCameraReady(false);
                    }}
                  />

                  {cameraStarting && <span className="client-camera-loader" />}

                  <span className="client-scan-corner client-scan-corner--tl" />
                  <span className="client-scan-corner client-scan-corner--tr" />
                  <span className="client-scan-corner client-scan-corner--bl" />
                  <span className="client-scan-corner client-scan-corner--br" />
                </div>

                <div className="client-scan-button-wrap">
                  <Button
                    type="button"
                    className="btn btn-secondary btn-scanBtn btnshadow client-scan-button"
                    onClick={() => {
                      setScanError(null);
                      setCameraStarting(true);
                      setCameraReady(false);
                      setIsOpen(true);
                    }}
                    disabled={loading || isOpen}
                  >
                    {isOpen ? t("scanning") : t("scan")}
                  </Button>
                </div>

                {/* <p className="text-center underline wtspText client-whatsapp-help">
                  {t("scanProductPage.whatsappHelp")}
                </p> */}


              </div>
            </div>
          </div>
        </div>
      </Layout>

      <CustomModal
        id={"genuinityCheckModal"}
        title={<></>}
        content={
          <>
            <div
              className="d-flex flex-column align-items-center"
              style={{ gap: "1rem" }}
            >
              <img src={Check} alt="check" />

              {scanedDataObject.productImageUrl && (<img
                src={scanedDataObject.productImageUrl}
                alt="GenuityCheck"
                style={{ width: '125px' }}
              />
              )}

              {scanedDataObject.primaryRewardMsg && (
                <p
                  className="mb-0 text-secondaryColor font-bold"
                  dangerouslySetInnerHTML={{
                    __html: scanedDataObject?.primaryRewardMsg,
                  }}
                />
              )}

              {scanedDataObject.secondaryRewardMsg && (
                <p
                  className="mb-0 text-sm"
                  dangerouslySetInnerHTML={{
                    __html: scanedDataObject?.secondaryRewardMsg,
                  }}
                />
              )}

              {scanedDataObject.scanLimitReached && (
                <p
                  className="genuityCheckLimitMsg text-center mb-0 px-2"
                  dangerouslySetInnerHTML={{
                    __html: scanLimitNotice.replace(/\r\n|\n|\r/g, "</br>"),
                  }}
                />
              )}
            </div>
          </>
        }
        footer={
          <div className="genuityCheckModalFooter w-100">
            {!scanedDataObject.scanLimitReached && (
              <Button
                className="w-100 rounded-4 py-2 btn-secondary btnshadow"
                onClick={handleGenuityProceedCashback}
              >
                {t("genuityCheck.proceedToCashback")}
              </Button>
            )}
          </div>
        }
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <CustomModal
        id={"spinModal"}
        title={""}
        content={
          <>
            <div>
              <img
                src={bannerLogoSrc}
                alt="Right"
                className="spinImgae spinwheelImg"
              />

              <CustomRoulette
                wheelItems={scanedDataObject.wheelItems}
                spinInnerImage={scanedDataObject.centerWheelImgUrl}
                stopPrizeNumber={stopPrizeNumber}
                closeModal={handleCloseModal}
              />

              <img
                src={LeftArrow}
                alt=""
                style={{
                  position: "absolute",
                  zIndex: "10",
                  bottom: "-20px",
                  left: "-7px",
                }}
              />

              <img
                src={RightArrow}
                alt=""
                style={{
                  position: "absolute",
                  zIndex: "10",
                  bottom: "-20px",
                  right: "-7px",
                }}
              />
            </div>
          </>
        }
        footer={
          <>
            {secondaryRewardMsg && (
              <p
                className="text-center my-2"
                style={{ fontSize: "0.9rem" }}
                dangerouslySetInnerHTML={{
                  __html: secondaryRewardMsg.replace(/\n/g, "</br>"),
                }}
              />
            )}

            {showRetailerInput && (
              <input
                type="text"
                className={`form-control shadow mb-1 ${mobileNumberError ? "is-invalid" : ""
                  }`}
                placeholder={t("mblnumberPlaceHolder")}
                name="retailerMblNbr"
                id="retailerMblNbr"
                maxLength="10"
                autoComplete="off"
                onInput={handleMblInput}
              />
            )}

            {mobileNumberError && (
              <div className="invalid-feedback">{mobileNumberError}</div>
            )}

            <Button onClick={handleSpin} className="w-100 rounded-4 py-2 btnshadow">
              {t("SpinWheel")}
            </Button>
          </>
        }
        show={spinModalShow}
        onHide={() => setSpinModalShow(false)}
      />

      <CustomModal
        id={"rewardUpdateModal"}
        title={
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={() => navigate(`/${lang}/giftHistory`)}
          >
            <img src={Close} alt="Close" />
          </button>
        }
        content={
          <>
            <img src={SuccessIcon} alt="SuccessIcon" className="succesIcon" />
            <img src={giftImageUrl} alt="Bottle" className="giftedImg" />

            <p className="congratulationsText mb-1 mt-1">
              {t("giftcongratulations")} !!!
            </p>

            <p
              className="rewardText mb-0"
              dangerouslySetInnerHTML={{
                __html: scanedDataObject.primaryRewardMsg,
              }}
            />
          </>
        }
        show={rewardUpdateModal}
        onHide={() => {
          setRewardUpdateModal(false);
          navigate(`/${lang}/giftHistory`);
        }}
      />

      <CustomModal
        id={"genuinityCheckModalError"}
        title={<></>}
        content={
          <>
            <img
              src={Wrongotp}
              alt="Wrongotp"
              className="img-fluid my-4 d-block mx-auto"
            />

            {scanedDataObject.primaryRewardMsg && (
              <p
                style={{
                  fontWeight: "600",
                  color: "#000000",
                  textAlign: "center",
                }}
              >
                {scanedDataObject?.primaryRewardMsg}
              </p>
            )}

            {scanedDataObject.secondaryRewardMsg && (
              <p
                style={{
                  fontWeight: "400",
                  color: "#000000",
                  textAlign: "center",
                }}
              >
                {scanedDataObject?.secondaryRewardMsg}
              </p>
            )}

            {/* {scanedDataObject.isSpinDone && (
              <p className="mb-0 modalInfo text-danger pt-2">
                {scanedDataObject?.primaryRewardMsg}
              </p>
            )} */}
          </>
        }
        footer={
          <>
            <div
              className="d-flex justify-content-between w-100"
              style={{ gap: ".5rem" }}
            >
              <Button
                className="w-100 rounded-4 py-2 btn-primary btnshadow"
                onClick={() => {
                  ReactGA.event({
                    category: "User Scan More",
                    action: "Clicked the Scan More Button",
                  });
                  window.location.reload();
                }}
              >
                {t('scanagain')}
              </Button>
            </div>
          </>
        }
        show={errorModalGenunity}
        onHide={() => setErrorModalGenunity(false)}
      />
    </>
  );
};
